

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { simplePlaceName } from '../../utils/utils';
import styles from './ExploreFurther.css';
import withStyles from '../../decorators/withStyles';
import {sameLocationNewHash, xlt} from "../../utils/utils";


class ExploreFurther extends Component {

  static propTypes = {
    placeType: PropTypes.string.isRequired,
    placeID: PropTypes.string.isRequired,
    placeName: PropTypes.string.isRequired,
    placeContainer: PropTypes.object.isRequired,
    relatedPlaces: PropTypes.array.isRequired,
    query: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { placeID, placeContainer, placeName }  = this.props;
    const places = this.props.relatedPlaces.filter(place =>
      place.id !== this.props.placeID || place.placetype !== this.props.placeType
    );
    // Add parenthesized place type for any two place names that are identical (e.g., New York (City) and New York (State)
    var seen = {};
    places.forEach((place, i) => {
      if (place.name in seen) {
        places[seen[place.name]].name += " (" +  places[seen[place.name]].placetype + ")";
        place.name += " (" +  place.placetype + ")";
      } else if (place.name === simplePlaceName(this.props.placeName)) {
        place.name += " (" +  place.placetype + ")";
      }

      seen[place.name] = i;
    });

    var containerID = placeContainer.placeID === "usa" ? placeID : placeContainer.placeID;
    var containerName = placeContainer.placeID === "usa" ? placeName : placeContainer.name;

    return (
      <section className="ExploreFurther">
        <div className="header">
          <a className="anchor" id="explore-further"/>
          <Link className="hash-link" to={sameLocationNewHash("#explore-further")}>
            <h1>Explore Related Places</h1>
          </Link>
        </div>
        <div className="placesList">
          <ul>{places.map(place => {
            place.placetype = place.placetype === "postal_code" ? "postal-code" : place.placetype;
            return (<li key={`/${place.placetype}/${place.id}`}>
              <Link to={{pathname: `/${place.placetype}/${place.id}`, query: this.props.query}}>
                {place.placetype === "postal-code" ? "Postal Code " + place.name : place.name}
              </Link>
            </li>)}
          )}
            {containerID !== "district-of-columbia.us" ?
              <div>
                <li><Link to={{pathname: "/congressional-district", query: {container: containerID}}}>
                  Congressional Districts in <var>{xlt(simplePlaceName(containerName))}</var></Link></li>
                <li><Link to={{pathname: "/state-assembly-district", query: {container: containerID}}}>
                  State Assembly Districts in <var>{xlt(simplePlaceName(containerName))}</var></Link></li>
                <li><Link to={{pathname: "/state-senate-district", query: {container: containerID}}}>
                  State Senate Districts in <var>{xlt(simplePlaceName(containerName))}</var></Link></li>
              </div>
              : null}
          </ul>
        </div>
      </section>
    );
  };
}

export default withStyles(styles)(ExploreFurther);
